/* Proof reminder: portrait PDPs, every purchase step. */
(() => {
  'use strict';
  if (window.lpArtworkProofNote || !/\/products\/[^/]+\/?$/.test(location.pathname)) return;
  let widget = null;
  const excluded = '.mw-tingle, quick-add-modal, .complementary-products, .product-card-wrapper';
  const controllers = new Map();
  const mobileQuery = matchMedia('(max-width: 749px)');
  const HOST = '[id="edd-embed-host"]';
  function visible(node) {
    if (!node || node.closest('[hidden], [aria-hidden="true"], .mw-group__hidden, ' + excluded) || !node.getClientRects().length) return false;
    for (let el = node; el instanceof Element; el = el.parentElement) {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }
  function attach(root) {
    if (controllers.has(root) || root.closest(excluded) || !['2d', '3d'].includes(root.dataset.lpBenefitsType)) return;
    let widget = null;
    let frame = null;
    let disposed = false;
    function hide() { if (widget && !widget.hidden) widget.hidden = true; }
    function place() {
      frame = null;
      if (disposed || !root.isConnected) return;
      const info = root.querySelector('.product__info-container');
      if (!info) { hide(); return; }
      const checkout = [...info.querySelectorAll('.lp-direct-checkout')].filter(el => !el.closest(excluded)).find(visible);
      const host = [...document.querySelectorAll(HOST)].filter(el => !el.closest(excluded)).find(visible);
      if (!checkout && !host) { hide(); return; }
      if (!widget) {
        widget = document.createElement('p');
        widget.className = 'lp-artwork-proof-note';
        widget.hidden = true;
        const text = document.createElement('span');
        text.append(document.createTextNode('Order now to see your preview draft in '));
        const strong = document.createElement('strong');
        strong.textContent = '2 biz days';
        text.append(strong);
        widget.append(text);
      }
      // Desktop: below the direct-checkout block, its timeline host included.
      // Mobile: below the timeline host, directly above the benefits list.
      // Steps 1-2 fall back to whichever anchor the visible step row exposes.
        if (mobileQuery.matches) {
          if (host) {
            if (host.nextElementSibling !== widget) host.after(widget);
          } else if (checkout) {
            if (widget.parentElement !== checkout) checkout.append(widget);
          } else { hide(); return; }
        } else {
          const row = host?.closest('.mw-group__button');
          if (checkout) {
            if (checkout.nextElementSibling !== widget) checkout.after(widget);
          } else if (row) {
            if (row.nextElementSibling !== widget) row.after(widget);
          } else if (host) {
            if (host.nextElementSibling !== widget) host.after(widget);
          } else { hide(); return; }
        }
      if (widget.hidden) widget.hidden = false;
    }
    function schedule() {
      if (!disposed && frame === null) frame = requestAnimationFrame(place);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    mobileQuery.addEventListener?.('change', schedule);
    controllers.set(root, {
      destroy() {
        disposed = true;
        observer.disconnect();
        mobileQuery.removeEventListener?.('change', schedule);
        if (frame !== null) cancelAnimationFrame(frame);
        widget?.remove();
        controllers.delete(root);
      }
    });
    schedule();
  }
  function initialize() {
    for (const [root, controller] of controllers) if (!root.isConnected) controller.destroy();
    document.querySelectorAll('main [id^="MainProduct-"]').forEach(attach);
  }
  window.lpArtworkProofNote = { refresh: initialize };
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of controllers) if (event.target.contains(root)) controller.destroy();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
